import { render } from "./AboutUsInput.vue?vue&type=template&id=2b17b7eb&lang=pug"
import script from "./AboutUsInput.vue?vue&type=script&setup=true&lang=js"
export * from "./AboutUsInput.vue?vue&type=script&setup=true&lang=js"

import "./AboutUsInput.vue?vue&type=style&index=0&id=2b17b7eb&lang=sass"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__